'use client';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { CMSSteps } from '@/api/cms/restrictions';
import { ImageComponent } from '@/components/Image';
import { useMatchingSection } from '@/modules/restrictions/hooks/useAccessSection';

import {
  ScStepsByGroup,
  ScStepsByGroupCard,
  ScStepsByGroupTitle,
} from './styled';

interface IStepsByGroup {
  title?: string;
  label?: string;
  hideDescription?: boolean;
  sections: CMSSteps[];
  imgSize?: { width: number; height: number };
  renderCard?: (step: CMSSteps['items'][number]) => React.ReactNode;
}

export const StepsByGroup: FC<IStepsByGroup> = ({
  title,
  label,
  hideDescription,
  sections,
  imgSize,
  renderCard,
}) => {
  const { t } = useTranslation('promotions');
  const section = useMatchingSection(sections);
  const cards = section?.items;

  if (!cards) return null;

  return (
    <ScStepsByGroup>
      <ScStepsByGroupTitle>
        {title || t('howToParticipate')}
      </ScStepsByGroupTitle>
      <div className="cards">
        {cards.map((card, index) =>
          renderCard ? (
            renderCard(card)
          ) : (
            <ScStepsByGroupCard className="card" key={card.id}>
              <ImageComponent
                alt={card.stepImage?.alternativeText || 'step card'}
                className="image"
                height={imgSize?.height || 128}
                src={card.stepImage?.url || ''}
                width={imgSize?.width || 84}
              />
              <p className="title">{card.title}</p>
              {!hideDescription && (
                <p className="description">{card.description}</p>
              )}
              {label && index === 0 && <p className="label">{label}</p>}
            </ScStepsByGroupCard>
          )
        )}
      </div>
    </ScStepsByGroup>
  );
};
